
export const dev_base_url = "http://192.168.3.30:9504/web"
export const publish_base_url = "https://api.sellmycode.com/web"

export const dev_domain = "http://localhost:3000";
export const publish_domain = "https://sellmycode.com"

// 放在香港
export const obs_prefix_url = "https://sellmycodecom.obs.ap-southeast-3.myhuaweicloud.com:443" 